import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/GlobalLogic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Qt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/layout-wrap.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/public/iconfont/iconfont.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mercedes-benz/oneweb-next-react-components/dist/style.css");
